import { APIProduct, Product } from "../types/products";

export const mapAPIProductToProduct = (product: APIProduct): Product => {
  return {
    id: product.id,
    orgId: product.org_id,
    companyId: product.company_id,
    description: product.description,
    baseUnitPrice: product.base_unit_price,
    satProductCode: product.sat_product_code,
    satMeasurementUnit: product.sat_measurement_unit,
    satTaxObject: product.sat_tax_object,
    internalSku: product.internal_sku,
    createdAt: product.created_at,
    updatedAt: product.updated_at,
  };
};
